<template>
  <div>
    <Modal
      :value="isOrgModal"
      :title="title"
      @on-visible-change="showChange"
      :mask-closable="false"
    >
      <Form :model="form" :rules="validation" ref="form" class="form" :label-width="100">
        <FormItem :label="msg.lib_id" prop="university_id">
          <Select
            v-model="form.university_id"
            filterable
            remote
            :remote-method="selfOrgList"
            :placeholder="`请输入学校名称`"
            ref="select"
            :loading="isSelectLoading"
          >
            <Option v-for="option in options" :value="option.university_id" :key="option.university_id">{{option.name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label="msg.name" prop="name">
          <Input :placeholder="`请输入管理员姓名`" :maxlength="10" v-model="form.name" clearable/>
        </FormItem>
        <FormItem :label="msg.mobile" prop="mobile">
          <Input :placeholder="`请输入${msg.mobile}`" v-model="form.mobile" clearable/>
        </FormItem>
        <FormItem :label="msg.telephone" prop="telephone">
          <Input :placeholder="`请输入${msg.telephone} ${phoneText}`" v-model="form.telephone" clearable/>
        </FormItem>
        <FormItem :label="msg.department" prop="department">
          <Input :placeholder="`例：图书馆阅读推广部`" v-model="form.department" clearable/>
        </FormItem>
        <FormItem :label="msg.position" prop="position">
          <Input :placeholder="`请输入${msg.position}`" v-model="form.position" clearable/>
        </FormItem>
        <FormItem :label="msg.reader_org_id">
          <Input :placeholder="`请输入${msg.reader_org_id}`" v-model="form.reader_org_id" clearable/>
        </FormItem>
        <FormItem :label="msg.reader_act_id">
          <Input :placeholder="`请输入${msg.reader_act_id}`" v-model="form.reader_act_id" clearable/>
        </FormItem>
        <FormItem :label="msg.email" prop="email">
          <Input :placeholder="`请准确填写，用于接收技术平台链接等`" v-model="form.email" clearable/>
        </FormItem>
        <FormItem :label="msg.address" prop="address">
          <Input :placeholder="`请准确填写收件地址、收件人姓名、电话号码，用于寄送证书等资料。`" v-model="form.address" clearable type="textarea" :autosize="{ minRows: 2, maxRows: 2 }"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Input, Form, FormItem, Select, Option } from 'view-design'
import { getOrgList, addOrg, editOrg } from '@/api/getApi'
export default {
  name: 'OrgModal',
  components: { Input, Form, FormItem, Select, Option },
  props: {
    isOrgModal: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        name: '',
        lib_type: '',
        university_id: '',
        telephone: '',
        mobile: '',
        department: '',
        position: '',
        code: '',
        reader_act_id: '',
        reader_org_id: '',
        email: '',
        address: ''
      },
      phoneText: '(区号—电话号码)',
      msg: {
        lib_id: '机构名称',
        name: '负责人',
        mobile: '手机号',
        code: '验证码',
        department: '所属部门',
        position: '职务',
        telephone: '座机号',
        address: '收件地址',
        email: '电子邮箱',
        reader_org_id: '机构标识',
        reader_act_id: '活动ID'
      },
      validation: {
        name: [{ required: true, message: `请输入负责人`, trigger: 'blur' }],
        university_id: [{ type: 'number', required: true, message: `请输入机构名称`, trigger: 'blur' }],
        telephone: [{ required: true, message: `请输入座机号码`, trigger: 'blur' },
          /* eslint-disable-next-line */
          { pattern: /^0?\d{2,3}\-\d{7,8}$/, message: `请输入正确的座机号`, trigger: 'blur' }],
        mobile: [{ required: true, message: `请输入手机号`, trigger: 'blur' },
          { pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: `请输入正确的手机号`, trigger: 'blur' }],
        department: [{ required: true, message: `请输入所属部门`, trigger: 'blur' }],
        position: [{ required: true, message: `请输入职务`, trigger: 'blur' }],
        email: [{ required: true, message: `请输入电子邮箱`, trigger: 'blur' },
          { pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, message: `请输入正确的电子邮箱`, trigger: 'blur' }],
        address: [{ required: true, message: `请输入收件地址`, trigger: 'blur' }]
      },
      isSelectLoading: false,
      options: [],
      orgCodeList: [],
      actIDList: [],
      actIDAll: []
    }
  },
  methods: {
    showChange (v) {
      this.$emit('update:isOrgModal', v)
    },
    async getSchoolList () {
      try {
        const res = await getOrgList()
        this.orgData = res.data || []
        await this.selfOrgList(this.form.university_id)
      } catch (e) {
        this.$Message.error(e)
      }
    },
    selfOrgList (str) {
      this.isSelectLoading = true
      if (this.orgData && this.orgData.length) {
        this.options = this.orgData.filter((val) => {
          if (val.name.includes(str) || val.university_id === Number(str)) {
            return val
          }
        })
      }
      this.isSelectLoading = false
    },
    submit () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const params = {
            name: this.form.name,
            mobile: this.form.mobile,
            telephone: this.form.telephone,
            position: this.form.position,
            department: this.form.department,
            // reader_act_id: this.form.reader_act_id,
            // reader_org_id: this.form.reader_org_id,
            university_id: this.form.university_id,
            address: this.form.address,
            email: this.form.email
          }
          const res = this.isEdit ? await editOrg(this.form.id, params) : await addOrg(params)
          if (res.code !== 200) {
            this.$Message.error(res.message)
            return false
          }
          this.$Message.success(`${this.title}成功`)
          this.$emit('update:isOrgModal', false)
          this.$emit('change')
        }
      })
    },
    cancel () {
      this.$refs.form.resetFields()
      this.$emit('update:isOrgModal', false)
    }
  },
  async created () {
    await this.getSchoolList()
  },
  mounted () {
    if (this.isEdit) {
      this.form = this.modalData
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑机构' : '新建机构'
    }
  }
}
</script>

<style lang = 'scss' scoped>
/deep/.ivu-input-wrapper, /deep/.ivu-select {
  width: 26rem;
}
/deep/.ivu-card-head p, /deep/.ivu-card-head-inner {
  font-size: 1.8rem;
  font-weight: bold;
}
.form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /deep/ .ivu-form-item-label {
    text-align: left;
    font-size: 1.6rem;
  }
}
</style>
